<template>
    <v-container>
        <page-header :title="`${mode === 'edit' ? 'Edit' : mode === 'show' ? '' : 'New'} Referee`.trim()" icon="mdi-whistle-outline" />
        <v-card class="form-card" elevation="1">
            <v-form :readonly="readOnly" @submit.prevent>
                <div class="form-section-title">
                    <v-icon small>mdi-card-account-details-outline</v-icon>Details
                </div>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="referee.name"
                            outlined
                            dense
                            hide-details="auto"
                            label="Name"
                            :rules="rules"
                            :clearable="clearable"
                        />
                    </v-col>
                </v-row>
            </v-form>
        </v-card>
        <div v-if="mode !== 'show'" class="form-actions">
            <v-spacer />
            <v-btn large text @click="$router.go(-1)">
                Cancel
            </v-btn>
            <v-btn :loading="loading" :disabled="!referee.name" class="white--text" large depressed color="black" @click="onSubmit">
                <v-icon left>mdi-content-save-outline</v-icon>Save
            </v-btn>
        </div>
        <alert :show-alert="showAlert" :message="message" type="error" />
    </v-container>
</template>

<script>
    import PageHeader from '@/components/PageHeader'
    import Alert from '@/components/Alert'
    import refereeService from '@/services/referee'

    export default {
        name: 'RefereeForm',
        components: { Alert, PageHeader },
        data: () => {
            return {
                showAlert: false,
                message: null,
                mode: null,
                readOnly: false,
                clearable: true,
                loading: false,
                refereeId: null,
                referee: {
                    name: ''
                },
                rules: [
                    v => !!v || 'Field is required'
                ]
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            this.refereeId = this.$route.params.refereeId
            if (this.refereeId) {
                refereeService.getReferee(this.refereeId).then(resp => {
                    this.referee = resp.data
                })
            }
        },
        methods: {
            onSubmit() {
                this.loading = true
                const request = this.mode === 'edit'
                    ? refereeService.updateReferee(this.refereeId, this.referee)
                    : refereeService.createReferee(this.referee)
                request.then(() => {
                    this.loading = false
                    this.$router.push('/referees')
                }).catch(error => {
                    this.loading = false
                    this.message = (error.response && error.response.data && error.response.data.message) || 'Could not save'
                    this.showAlert = true
                    setTimeout(() => { this.showAlert = false }, 7000)
                })
            }
        }
    }
</script>
